// Responsive Font Utility - Erstellt CSS für responsive Font-Größen

export const getResponsiveFontSize = (baseSize, mobileSize, bigSize) => {
    const mobile = mobileSize || baseSize;
    const normal = baseSize;
    const big = bigSize || baseSize;
    
    return {
        fontSize: `${normal}px`,
        '@media (max-width: 750px)': {
            fontSize: `${mobile}px`
        },
        '@media (min-width: 1400px)': {
            fontSize: `${big}px`
        }
    };
};

export const getResponsiveFontWeight = (baseWeight, mobileWeight, bigWeight) => {
    const mobile = mobileWeight || baseWeight;
    const normal = baseWeight;
    const big = bigWeight || baseWeight;
    
    return {
        fontWeight: normal,
        '@media (max-width: 750px)': {
            fontWeight: mobile
        },
        '@media (min-width: 1400px)': {
            fontWeight: big
        }
    };
};

// CSS-in-JS Style Generator für responsive Fonts
export const createResponsiveTextStyle = (data, fieldPrefix, defaultSize, defaultWeight) => {
    const baseSize = data[`${fieldPrefix}Size`] || defaultSize;
    const mobileSize = data[`${fieldPrefix}SizeMobile`];
    const bigSize = data[`${fieldPrefix}SizeBig`];
    
    const baseWeight = data[`${fieldPrefix}Weight`] || defaultWeight;
    const mobileWeight = data[`${fieldPrefix}WeightMobile`];
    const bigWeight = data[`${fieldPrefix}WeightBig`];

    // Erstelle Media Query Styles
    const style = {
        fontSize: `${baseSize}px`,
        fontWeight: baseWeight
    };

    // Füge CSS-in-JS Media Queries hinzu (für styled-components oder emotion)
    if (mobileSize) {
        style['@media (max-width: 750px)'] = {
            fontSize: `${mobileSize}px`
        };
    }
    
    if (bigSize) {
        style['@media (min-width: 1400px)'] = {
            fontSize: `${bigSize}px`
        };
    }

    if (mobileWeight) {
        style['@media (max-width: 750px)'] = {
            ...style['@media (max-width: 750px)'],
            fontWeight: mobileWeight
        };
    }

    if (bigWeight) {
        style['@media (min-width: 1400px)'] = {
            ...style['@media (min-width: 1400px)'],
            fontWeight: bigWeight
        };
    }

    return style;
};
